/**
 * Formata um número de telefone com máscara
 * @param {string} value - Número de telefone (com ou sem máscara)
 * @returns {string} - Número formatado com máscara
 */
export const formatPhone = (value) => {
  if (!value) return '';
  
  // Remove tudo que não é número
  const numbers = value.replace(/\D/g, '');
  
  // Aplica a máscara
  let masked = numbers;
  if (numbers.length <= 10) {
    // Formato: (00) 0000-0000
    if (numbers.length > 6) {
      masked = numbers.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
    } else if (numbers.length > 2) {
      masked = numbers.replace(/(\d{2})(\d{0,4})/, '($1) $2');
    } else if (numbers.length > 0) {
      masked = numbers.replace(/(\d{0,2})/, '($1');
    }
  } else {
    // Formato: (00) 00000-0000
    masked = numbers.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
  }
  
  return masked;
};

/**
 * Remove a máscara do telefone, retornando apenas números
 * @param {string} value - Número de telefone com máscara
 * @returns {string} - Apenas números
 */
export const unformatPhone = (value) => {
  if (!value) return '';
  return value.replace(/\D/g, '');
};

/**
 * Gera um link do WhatsApp para o número de telefone
 * @param {string} phoneNumber - Número de telefone (com ou sem máscara)
 * @returns {string} - URL do WhatsApp
 */
export const getWhatsAppLink = (phoneNumber) => {
  if (!phoneNumber) return '';
  
  // Remove tudo que não é número
  const numbers = unformatPhone(phoneNumber);
  
  // Adiciona o código do país (55 para Brasil) se não tiver
  const fullNumber = numbers.startsWith('55') ? numbers : `55${numbers}`;
  
  return `https://wa.me/${fullNumber}`;
};
